module.exports = __webpack_public_path__ + "img/immleft.ac528c53.png";